/**
 * register-teacher.js
 */

import { messages } from "../../exports/validation";

$('#teachers').validate({
    errorClass: 'has-error',
    messages: {
        name: messages.name,
        email: messages.email,
        phone: messages.phone,
        mobile_phone: messages.mobile_phone,
        address: messages.address,
        estado: messages.state,
        cidade: messages.city,
        lattes: { required: "Por favor, informe o link do seu currículo Lattes", url: "Informe uma URL válida" },
        message: messages.message,
    }
});
